import {destroy, download, mutate, query, update} from "../../defaults/fetch";
import {useEffect, useState} from "react";


export const useGetMemos = ()=>{

    /**
     * @description Gets memos/claims for creating vouchers
     * @param {string} year
     * @param {string|null} type
     * @param {boolean} voucher
     * @returns {Promise<*>}
     */
    const getMemos = async(year, type, voucher = false)=>{
        const url = `memo/get-all`;
        const qs = {
            year: year, type: type, voucher: voucher
        }
        const {data} = await query(url, qs);
        return data
    }

    return getMemos;
}

export const useGetPaginatedMemos = () => {
    /**
     * @description Gets paginated memos with filters
     * @param {number} page - Page number (default: 0)
     * @param {number} size - Page size (default: 10)
     * @param {string} year - Financial year ID (required)
     * @param {string} creatorId - Creator ID (optional)
     * @param {string} title - Memo title for filtering (optional)
     * @param {string} type - Memo type (optional)
     * @param {string} approvalStatus - Approval status filter (optional)
     * @returns {Promise<*>}
     */
    const getPaginatedMemos = async (page = 0, size = 10, year, creatorId, title, type, approvalStatus) => {
        const url = `memo/get-paginated`;
        const qs = {
            page,
            size,
            year,
            creatorId,
            title,
            type,
            approvalStatus
        };
        const { data } = await query(url, qs);
        return data;
    };

    return getPaginatedMemos;
}


export const useCreateMemo = ()=>{
    const createMemo = async(body)=>{
        const url = `memo/create/memo`;
        const {message} = await mutate(url,true,body, {}, "multipart/form-data", true);
        return message;
    }
    return createMemo;
}

export const useCreateClaim = ()=>{
    const createClaim = async(body)=>{
        const url = `memo/create/claim`;
        const {message} = await mutate(url,true,body, {}, 'multipart/form-data', true);
        return message;
    }
    return createClaim;
}

export const useUpdateMemo = ()=>{
    const updateMemo = async(id,body)=>{
        const url = `memo/update/memo/${id}`;
        const {message} = await update(url,body, {}, 'multipart/form-data', true);
        return message;
    }
    return updateMemo;
}

export const useUpdateClaim = ()=>{
    const updateClaim = async(id,body)=>{
        const url = `memo/update/claim/${id}`;
        const {message} = await update(url,body, {}, "multipart/form-data", true);
        return message;
    }
    return updateClaim;
}

export const useRequestMemoRecommendation = ()=>{
    const requestRecommendation = async (id)=>{
        const url = `memo/request-recommendation/${id}`;
        const {message} = await update(url);
        return message;
    }
    return requestRecommendation;
}


export const useHODRecommend = ()=>{
    const hodRecommend = async (id)=>{
        const url = `memo/hod-recommend/${id}`;
        const {message} = await update(url);
        return message;
    }
    return hodRecommend;
}


export const useReverseHODRecommend = ()=>{
    const hodReverseRecommend = async (id)=>{
        const url = `memo/hod-reject-recommendation/${id}`;
        const {message} = await update(url);
        return message;
    }
    return hodReverseRecommend;
}

export const useHOFRecommend = ()=>{
    const hofRecommend = async (id)=>{
        const url = `memo/hof-recommend/${id}`;
        const {message} = await update(url);
        return message;
    }
    return hofRecommend;
}


export const useReverseHOFRecommend = ()=>{
    const hofReverseRecommend = async (id)=>{
        const url = `memo/hof-reject-recommendation/${id}`;
        const {message} = await update(url);
        return message;
    }
    return hofReverseRecommend;
}



export const useHOURecommend = ()=>{
    const houRecommend = async (id)=>{
        const url = `memo/hou-recommend/${id}`;
        const {message} = await update(url);
        return message;
    }
    return houRecommend;
}

export const useReverseHOURecommend = ()=>{
    const houReverseRecommend = async (id)=>{
        const url = `memo/hou-reject-recommendation/${id}`;
        const {message} = await update(url);
        return message;
    }
    return houReverseRecommend;
}


export const useVCApproval = ()=>{
    const vcApprove = async (id)=>{
        const url = `memo/vc-approval/${id}`;
        const {message} = await update(url);
        return message;
    }
    return vcApprove;
}


export const useReverseVCApproval = ()=>{
    const vcReverseApprove = async (id)=>{
        const url = `memo/vc-reject-approval/${id}`;
        const {message} = await update(url);
        return message;
    }
    return vcReverseApprove;
}


export const useBursarApproval = ()=>{
    const bursarApprove = async (id)=>{
        const url = `memo/bursar-approval/${id}`;
        const {message} = await update(url);
        return message;
    }
    return bursarApprove;
}


export const useReverseBursarApproval = ()=>{
    const bursarReverseApprove = async (id)=>{
        const url = `memo/bursar-reject-approval/${id}`;
        const {message} = await update(url);
        return message;
    }
    return bursarReverseApprove;
}


export const useDeleteMemo = ()=>{
    const deleteMemo = async(id)=>{
        const url = `memo/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteMemo;
}

export const useDownloadMemo = () => {
    return async (id) => {
        const url = `memo/get-memo-document/${id}`
        const message = await download(url, `memo-${id}`, 'pdf', true)
        return message;
    };
}

export const useGetMemoComments = () => {
    const getMemoComments = async (memoId) => {
        const url = `memo/get-comments`;
        const qs = { memo: memoId };
        const { data } = await query(url, qs);
        return data;
    }
    return getMemoComments;
}

export const useAddMemoComment = () => {
    const addMemoComment = async (payload) => {
        const url = `memo/add-comment`;
        const { data } = await mutate(url, true, payload);
        return data;
    }
    return addMemoComment;
}

export const useUpdateMemoComment = () => {
    const updateMemoComment = async (payload) => {
        const url = `memo/update-comment`;
        const { data } = await mutate(url, true, payload);
        return data;
    }
    return updateMemoComment;
}

export const useDeleteMemoComment = () => {
    const deleteMemoComment = async (commentId) => {
        const url = `memo/delete-comment/${commentId}`;
        const { message } = await destroy(url);
        return message;
    }
    return deleteMemoComment;
}


// New hooks for memo recommendation feature
export const useRequestComment = () => {
    const requestComment = async (payload) => {
        const url = `memo/request-comment`;
        const { data } = await mutate(url, true, payload);
        return data;
    }
    return requestComment;
}

export const useReturnWithComment = () => {
    const returnWithComment = async (payload) => {
        const url = `memo/return-with-comment`;
        const { data } = await mutate(url, true, payload);
        return data;
    }
    return returnWithComment;
}

export const useGetMemosAwaitingMyComment = () => {
    const getMemosAwaitingMyComment = async (year) => {
        const url = `memo/awaiting-my-comment`;
        const qs = { year };
        const { data } = await query(url, qs);
        return data;
    }
    return getMemosAwaitingMyComment;
}

export const useGetPaginatedMemosAwaitingMyComment = () => {
    const getPaginatedMemosAwaitingMyComment = async (page = 0, size = 10, year) => {
        const url = `memo/awaiting-my-comment`;
        const qs = { page, size, year };
        const { data } = await query(url, qs);
        return data;
    }
    return getPaginatedMemosAwaitingMyComment;
}
